var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8535 21.3426L16.4605 15.9496C17.5135 14.5956 18.1465 12.8976 18.1465 11.0496C18.1465 6.63156 14.5645 3.04956 10.1465 3.04956C5.72848 3.04956 2.14648 6.63156 2.14648 11.0496C2.14648 15.4676 5.72848 19.0496 10.1465 19.0496C11.9945 19.0496 13.6925 18.4166 15.0465 17.3636L20.4395 22.7566L21.8535 21.3426ZM10.1465 17.0496C6.83848 17.0496 4.14648 14.3576 4.14648 11.0496C4.14648 7.74156 6.83848 5.04956 10.1465 5.04956C13.4545 5.04956 16.1465 7.74156 16.1465 11.0496C16.1465 14.3576 13.4545 17.0496 10.1465 17.0496Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchM);
export default __webpack_public_path__ + "static/media/search-M.dd02c9a70c3947c1fae965a51a334a99.svg";
export { ForwardRef as ReactComponent };